module.exports = __webpack_public_path__ + "img/bell-ring-outline.87b01a15.svg";